// extracted by mini-css-extract-plugin
export default {"container":"quiz_container__-Wy6Z","content":"quiz_content__gKZq7","header":"quiz_header__yOWUY"};